import { Box, Card, CardProps, Typography, Img } from "@xcorejs/ui";
import { resolveSrcSet } from "utils";

export type OwnerCardProps = {
  imgSrc: string;
  name: string;
  occupation: string;
  info: string;
} & CardProps;

const OwnerCard = ({ imgSrc, name, occupation, info, ...props }: OwnerCardProps) => {
  return (
    <Card
      variant="elevated"
      media={<Img src={imgSrc} {...resolveSrcSet(imgSrc, imgSrc)} alt={name} width="43rem" maxWidth="100%" loading="lazy" />}
      _media={{ background: "#DEE1E5", justifyContent: "center", alignItems: "center" }}
      body={
        <Box width="100%">
          <Typography variant="h3" textAlign="center">
            {name}
          </Typography>
          <Typography variant="p" textAlign="center" color="#E00034" fontWeight={700} mb="3rem">
            {occupation}
          </Typography>
          <Typography variant="p" textAlign="center">
            {info}
          </Typography>
        </Box>
      }
      _body={{
        padding: "5rem 3rem 5rem 3rem",
      }}
      boxShadow="none"
      width="100%"
      minWidth="100%"
      {...props}
    />
  );
};

export default OwnerCard;
